module.exports = __webpack_public_path__ + "static/media/go-back.37a86537.svg";